let gtmInitialized = false;

export const initGTM = () => {
  if (typeof window === "undefined") return;
  if (gtmInitialized) return;

  const gtmId = process.env.REACT_APP_GTM_ID;

  if (!gtmId) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("GTM ID (REACT_APP_GTM_ID) is not set");
    }
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const firstScript = document.getElementsByTagName("script")[0];
  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    gtmId
  )}`;

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  } else {
    document.head.appendChild(gtmScript);
  }

  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("Initialized GTM with ID:", gtmId);
  }

  gtmInitialized = true;
};

export const pushDataLayerEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
};

